import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "../views/signIn.vue";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'signin',
    component: SignIn,
  },
  {
    path: "/signup",
    name: "signup",
    component: () =>
      import(
            /* WebpackChunckName: "signup" */ "@/views/SignUp"
      )
  },
  {
    path: '/reset-password/:token/:email',
    name: 'resetPassword',
    component: () =>
      import(
            /* WebpackChunckName: "ResetPassword" */ "@/views/ResetPassword"
      ),
    beforeEnter: (to, from, next) => {
      if (store.state.forgotToken) {
        next();
      } else {
        next("/login");
      }
    }
  },

  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () =>
      import( /* WebpackChunckName: "forgot-password" */ '@/views/ForgotPassword')
  },
  {
    path: '/supportedDoc',
    name: 'supporteddocument',
    component: () =>
      import( /* WebpackChunckName: "forgot-password" */ '@/views/SupportedDoc'),
      beforeEnter: (to, from, next) => {
        if (store.getters.getUserId) {
          next()
        } else {
          next("/")
        }
      }
  },

  {
    path: '/application',
    name: 'Application',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "signin" */ '../views/Application.vue'),
    beforeEnter: (to, from, next) => {
      if (store.getters.getUserId) {
        next()
      } else {
        next("/")
      }
    }
  },
  {
    path: '/thankyou',
    name: 'Thankyou',
    component: () => import( /* webpackChunkName: "thankyou" */ '../views/ThankYou.vue')

  },

  {
    path: "/404",
    name: "Error404",
    component: () => import( /* webpackChunkName: "error404" */ '../views/Error.vue')
  },
  {
    path: "/*",
    beforeEnter: (to, from, next) => {
      if (store.getters.getUserId) {
        next('/application');
      } else {
        next("/");
      }
    }

  },

];





const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
